<template>
  <Dialog 
    v-model:visible="visible" 
    modal 
    :header="category && category.id ? 'Editar Categoria' : 'Nova Categoria'" 
    class="w-full max-w-md mx-4"
    :closable="!loading"
    @hide="handleClose"
  >
    <form @submit.prevent="handleSubmit" class="flex flex-col gap-4 mt-2">
      
      <div class="flex flex-col gap-1">
        <label for="cat-name" class="text-sm font-semibold text-secondary">
          Identificador Interno (Código/Name)
        </label>
        <InputText 
          id="cat-name" 
          v-model="form.name" 
          placeholder="ex: web-development" 
          class="w-full"
          :disabled="loading"
          required
        />
      </div>

      <div class="flex flex-col gap-1 mt-2">
        <label class="text-sm font-semibold text-secondary mb-1">Traduções Exibidas</label>
        
        <Tabs value="en">
          <TabList>
            <Tab value="en" class="flex items-center gap-2">
              <img :src="getOnPublic('/flags/en.svg')" class="w-4 h-3 object-cover rounded-sm" alt="EN" /> EN
            </Tab>
            <Tab value="pt" class="flex items-center gap-2">
              <img :src="getOnPublic('/flags/br.svg')" class="w-4 h-3 object-cover rounded-sm" alt="PT" /> PT
            </Tab>
            <Tab value="es" class="flex items-center gap-2">
              <img :src="getOnPublic('/flags/es.svg')" class="w-4 h-3 object-cover rounded-sm" alt="ES" /> ES
            </Tab>
          </TabList>
          
          <TabPanels>
            <TabPanel value="pt" class="pt-3">
              <div class="flex flex-col gap-1">
                <label for="lang-pt" class="text-xs text-gray-500">Nome em Português *</label>
                <InputText id="lang-pt" v-model="form.pt" placeholder="Desenvolvimento Web" class="w-full" required :disabled="loading" />
              </div>
            </TabPanel>
            
            <TabPanel value="en" class="pt-3">
              <div class="flex flex-col gap-1">
                <label for="lang-en" class="text-xs text-gray-500">Nome em Inglês *</label>
                <InputText id="lang-en" v-model="form.en" placeholder="Web Development" class="w-full" required :disabled="loading" />
              </div>
            </TabPanel>
            
            <TabPanel value="es" class="pt-3">
              <div class="flex flex-col gap-1">
                <label for="lang-es" class="text-xs text-gray-500">Nome em Espanhol *</label>
                <InputText id="lang-es" v-model="form.es" placeholder="Desarrollo Web" class="w-full" required :disabled="loading" />
              </div>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </div>

      <div class="flex justify-end gap-2 mt-4 border-t border-iron pt-4">
        <Button 
          type="button" 
          label="Cancelar" 
          severity="secondary" 
          variant="text" 
          @click="visible = false" 
          :disabled="loading"
        />
        <Button 
          type="submit" 
          :label="category.id ? 'Salvar Alterações' : 'Cadastrar'" 
          class="bg-button"
          :icon="loading ? 'pi pi-spin pi-spinner' : 'pi pi-check'" 
          :disabled="loading"
        />
      </div>
    </form>
  </Dialog>
</template>

<script setup>
import { ref, watch, reactive, defineProps, defineEmits } from 'vue';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import { getOnPublic } from '@/composables/imageChecker';

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  category: { type: Object, default: () => ({ id: null, name: '', pt: '', en: '', es: '' }) },
  loading: { type: Boolean, default: false }
});

const emit = defineEmits(['update:modelValue', 'save']);

const visible = ref(props.modelValue);

const form = reactive({
  id: null,
  name: '',
  pt: '',
  en: '',
  es: ''
});

watch(() => props.modelValue, (newVal) => {
  visible.value = newVal;
});

watch(visible, (newVal) => {
  emit('update:modelValue', newVal);
});

watch(() => props.category, (newCat) => {
  if (newCat) {
    form.id = newCat.id || null;
    form.name = newCat.name || '';
    form.pt = newCat.pt || '';
    form.en = newCat.en || '';
    form.es = newCat.es || '';
  }
}, { immediate: true, deep: true });

const handleClose = () => {
  // Reset básico do form se necessário ao fechar
};

const handleSubmit = () => {
  emit('save', { ...form });
};
</script>